import Home from './pages/Home';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import RegisterDemo from './pages/RegisterDemo';
import Pricing from './pages/Pricing';
import PaymentSuccess from './pages/PaymentSuccess';
import InnerPage from './pages/InnerPage';
import PrivacyPolicy from './pages/PrivacyPolicy';
import { comingSoonPages } from './data/siteNav';
import { HelmetProvider } from 'react-helmet-async';

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <Router>
          <Routes>
            <Route index element={<Home />} />
            <Route path="/home" element={<Home />} />
            <Route path="/register-for-demo" element={<RegisterDemo />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/pricing/success" element={<PaymentSuccess />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            {comingSoonPages.map((page) => (
              <Route
                key={page.to}
                path={page.to}
                element={<InnerPage path={page.to} title={page.label} parent={page.parent} />}
              />
            ))}
          </Routes>
        </Router>
      </HelmetProvider>
    </div>
  );
}

export default App;
